import { jsx as i } from "react/jsx-runtime";
import { c as f } from "react/compiler-runtime";
import { Toolbar as m } from "@mui/material";
function a(t) {
  const o = f(6);
  let r, e;
  o[0] !== t ? ({
    children: r,
    ...e
  } = t, o[0] = t, o[1] = r, o[2] = e) : (r = o[1], e = o[2]);
  let l;
  return o[3] !== r || o[4] !== e ? (l = /* @__PURE__ */ i(m, { ...e, children: r }), o[3] = r, o[4] = e, o[5] = l) : l = o[5], l;
}
export {
  a as Toolbar
};
